import { useEffect, useState } from "react";
import LoadingPage from "../pages/layout.tsx/loading";
import { request } from "../api/config-psikolog";

type Props = {
  children: JSX.Element | JSX.Element[];
};

const Guest = ({ children }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);

  const checkSession = async () => {
    try {
      await request.get("/profile").then(() => {
        // navigate(-1);
      });
    } catch {
      return;
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([checkSession()]).then((res) => {
      setLoading(false);
    });
  }, []);

  return <>{loading ? <LoadingPage /> : <>{children}</>}</>;
};

export default Guest;
